/*
 * Models used by the topic example modal
 */

define(["backbone", "messaging/messenger", "configuration/properties"], function (
  Backbone,
  Messenger,
  Properties,
) {
  var exampleEditorModel = {};

  exampleEditorModel.substGroupMatch = Backbone.Model.extend({
    defaults: {
      substitutionGroupId: 0,
      substitutionGroupName: "",
      matchingEntry: "",
      multiWord: false,
    },
  });

  exampleEditorModel.substGroupMatches = Backbone.Collection.extend({
    model: exampleEditorModel.substGroupMatch,
    comparator: function (a, b) {
      return Backbone.textComparator(a, b, "substitutionGroupName");
    },
  });

  Messenger.reqres.setHandler(
    "example:entry:substitution:matches",
    function (exampleEntries, index) {
      var matches = new exampleEditorModel.substGroupMatches();
      matches.url = function () {
        var kbId = Messenger.reqres.request("active:kb");
        return Properties.rootURL + "/" + kbId + "/substitutions/index/" + index;
      };
      //override fetch
      matches.fetch = function (options) {
        options = options ? _.clone(options) : {};
        if (options.parse === void 0) options.parse = true;
        var success = options.success;
        var collection = this;
        options.success = function (resp) {
          var method = options.reset ? "reset" : "set";
          collection[method](resp, options);
          if (success) success(collection, resp, options);
          collection.trigger("sync", collection, resp, options);
        };
        //clone to avoid events firing on the original exampleEntries
        return this.sync("update", exampleEntries.clone(), options); //use 'update' to create PUT and pass exampleEntries into body
      };
      matches.fetch({ url: matches.url() }); //use the url defined above, not the URL of the example entries we pass
      matches.once("sync", function () {
        this.sort();
      });
      return matches;
    },
  );

  return exampleEditorModel;
});
